"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _uiKit = require("@devsta/ui-kit");

var _CreditsRemaining = _interopRequireDefault(require("../../CreditsRemaining"));

var _TeamAllocation = _interopRequireDefault(require("./TeamAllocation"));

require("../styles/_allocate-credits-modal.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DISPLAY_LIMIT = 4;

function itemMatchesFilter(item, filter) {
  return Object.values(item).some(function (itemField) {
    return itemField && typeof itemField === 'string' && itemField.toLowerCase().includes(filter.toLowerCase());
  });
}

var AllocateCreditsModal = /*#__PURE__*/function (_Component) {
  _inherits(AllocateCreditsModal, _Component);

  function AllocateCreditsModal(props) {
    var _this;

    _classCallCheck(this, AllocateCreditsModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AllocateCreditsModal).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onSearchChange", (0, _lodash.default)(function (_ref) {
      var value = _ref.target.value;
      var teams = _this.props.teams;

      if (!value) {
        return void _this.setState({
          filteredTeams: teams
        });
      }

      _this.setState({
        filteredTeams: teams.filter(function (item) {
          return itemMatchesFilter(item, value);
        })
      });
    }, 250));

    _defineProperty(_assertThisInitialized(_this), "setSearchInputRef", function (ref) {
      if (_this._searchInputRef || !ref) {
        return;
      }

      _this._searchInputRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "handleCreditChange", function (teamToUpdate) {
      return function (value) {
        var _this$props = _this.props,
            orgBalance = _this$props.orgBalance,
            isUnlimited = _this$props.isUnlimited,
            onCreditsAllocationChange = _this$props.onCreditsAllocationChange;
        var creditsDiff = isUnlimited ? 0 : value - (0, _lodash2.default)(teamToUpdate, 'creditBalance.balance', 0);

        if (orgBalance <= 0 && creditsDiff >= 1) {
          return;
        }

        var updatedTeam = _objectSpread({}, teamToUpdate, {
          creditBalance: _objectSpread({}, teamToUpdate.creditBalance, {
            balance: value
          })
        });

        onCreditsAllocationChange({
          updatedTeam: updatedTeam,
          updatedOrgBalance: orgBalance - creditsDiff
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleDeleteCreditRule", function (_ref2) {
      var teamToUpdate = _ref2.teamToUpdate,
          creditRuleId = _ref2.creditRuleId,
          creditQuantity = _ref2.creditQuantity;
      return (/*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _this$props2, deleteCreditRule, onDeleteCreditRule, orgRecurringBalance, isUnlimited, _ref4, data, error, updatedTeam;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this$props2 = _this.props, deleteCreditRule = _this$props2.deleteCreditRule, onDeleteCreditRule = _this$props2.onDeleteCreditRule, orgRecurringBalance = _this$props2.orgRecurringBalance, isUnlimited = _this$props2.isUnlimited;
                  _context.next = 3;
                  return deleteCreditRule(creditRuleId);

                case 3:
                  _ref4 = _context.sent;
                  data = _ref4.data;
                  error = _ref4.error;

                  if (!(!data || error)) {
                    _context.next = 8;
                    break;
                  }

                  return _context.abrupt("return");

                case 8:
                  updatedTeam = _objectSpread({}, teamToUpdate, {
                    creditRule: void 0
                  });
                  onDeleteCreditRule({
                    updatedTeam: updatedTeam,
                    orgRecurringBalance: isUnlimited ? orgRecurringBalance : orgRecurringBalance + creditQuantity
                  });

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      );
    });

    _defineProperty(_assertThisInitialized(_this), "handleAllocateCreditsSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props3, updateTeamCredits, onSave, updatedTeams, updateData, _ref7, data, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props3 = _this.props, updateTeamCredits = _this$props3.updateTeamCredits, onSave = _this$props3.onSave, updatedTeams = _this$props3.updatedTeams;

              if (!(!updatedTeams || !updatedTeams.length)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              updateData = updatedTeams.map(function (_ref6) {
                var _ref6$creditBalance = _ref6.creditBalance;
                _ref6$creditBalance = _ref6$creditBalance === void 0 ? {} : _ref6$creditBalance;
                var balanceId = _ref6$creditBalance.balanceId,
                    balance = _ref6$creditBalance.balance;
                return {
                  balanceId: balanceId,
                  balance: balance
                };
              });
              _context2.next = 6;
              return updateTeamCredits(updateData);

            case 6:
              _ref7 = _context2.sent;
              data = _ref7.data;
              error = _ref7.error;

              if (!(!data || error)) {
                _context2.next = 11;
                break;
              }

              return _context2.abrupt("return");

            case 11:
              onSave(data.updateTeamCredits);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _this.state = {
      filteredTeams: void 0,
      filter: ''
    };
    return _this;
  }

  _createClass(AllocateCreditsModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          isVisible = _this$props4.isVisible,
          teams = _this$props4.teams,
          onClose = _this$props4.onClose,
          creditType = _this$props4.creditType,
          onCreditTypeChange = _this$props4.onCreditTypeChange,
          isSetRecurringMode = _this$props4.isSetRecurringMode,
          orgBalance = _this$props4.orgBalance,
          isUnlimited = _this$props4.isUnlimited,
          updatedTeams = _this$props4.updatedTeams,
          onGoToSetRecurring = _this$props4.onGoToSetRecurring;
      var _this$state = this.state,
          _this$state$filteredT = _this$state.filteredTeams,
          filteredTeams = _this$state$filteredT === void 0 ? teams : _this$state$filteredT,
          filter = _this$state.filter;

      if (!filteredTeams) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "allocate-credits-modal"
      }, _react.default.createElement(_uiKit.FormModal, {
        title: "Manage Credits",
        visible: isVisible && !isSetRecurringMode,
        onClose: onClose,
        onSave: this.handleAllocateCreditsSave,
        saveDisabled: !updatedTeams || !updatedTeams.length
      }, _react.default.createElement("p", {
        className: "allocate-credits-modal__header"
      }, "Credit Setting"), _react.default.createElement("div", {
        className: "allocate-credits-modal__credit-setting"
      }, _react.default.createElement(_CreditsRemaining.default, {
        balance: orgBalance,
        isUnlimited: isUnlimited
      }), _react.default.createElement(_uiKit.Dropdown, {
        id: "team-admin",
        label: "CREDIT TYPE*",
        onChange: onCreditTypeChange,
        defaultValue: creditType,
        value: creditType,
        defaultOptions: true,
        options: [{
          label: 'SHARE',
          value: 'SHARE'
        }, {
          label: 'TEAM',
          value: 'TEAM'
        }],
        upperCaseLabels: true
      })), creditType === 'TEAM' && filteredTeams.length ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
        className: "allocate-credits-modal__current-allocation-header"
      }, _react.default.createElement(_uiKit.Input, {
        ref: this.setSearchInputRef,
        prefix: "search",
        placeholder: "Search",
        value: filter,
        onChange: this.onSearchChange
      })), _react.default.createElement("div", {
        className: "allocate-credits-modal__current-allocation"
      }, filteredTeams.map(function (team, index) {
        if (index >= DISPLAY_LIMIT) {
          return null;
        }

        return _react.default.createElement(_TeamAllocation.default, {
          key: team.teamId,
          team: team,
          orgBalance: orgBalance,
          onChangeNumber: _this2.handleCreditChange,
          onGoToSetRecurring: onGoToSetRecurring,
          onDeleteCreditRule: _this2.handleDeleteCreditRule
        });
      }))) : null));
    }
  }]);

  return AllocateCreditsModal;
}(_react.Component);

exports.default = AllocateCreditsModal;